import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSideBar } from "../../redux/slices/SidebarSlice";
import logo from "../../asessts/Images/logo.png";
import barIcon from "../../asessts/Images/bar_icon.svg";
import timesIcon from "../../asessts/Images/times_icon.svg";
import dashborad from "../../asessts/Images/dashboard_icon.svg";
import settingIcon from "../../asessts/Images/setting_icon.svg";
import request from "../../asessts/Images/request_icon.svg";
import facility from "../../asessts/Images/facility_icon.svg";
import { NavLink, useLocation } from "react-router-dom";

function Sidebar() {
  const sideBarSlice = useSelector((state) => state.sideBarSlice.sideBar);
  const dispatch = useDispatch();
  const location = useLocation();

  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isDesktop) {
      dispatch(setSideBar(false));
    }
  }, [location.pathname, isDesktop, dispatch]);

  const toggleSidebar = () => {
    dispatch(setSideBar(!sideBarSlice));
  };

  const getActiveClass = (basePath) =>
    location.pathname.startsWith(basePath) ? "active" : "";

  return (
    <div
      className={`dashboard-menu ${
        isDesktop && sideBarSlice
          ? "dashboard-active"
          : sideBarSlice
          ? "menu-active"
          : ""
      }`}
    >
      <div className="logo">
        <div className="logo-img">
          <NavLink to="/dashboard">
            <img src={logo} alt="Logo" />
          </NavLink>
        </div>
        <div className="tab-menu-bar">
          <button className="barBtn" onClick={toggleSidebar}>
            <img src={sideBarSlice ? timesIcon : barIcon} alt="toggle icon" />
          </button>
        </div>
      </div>

      <div className="dashboard-options">
        <ul className="p-0">
          <li>
            <NavLink
              to="/dashboard"
              className={() => getActiveClass("/dashboard")}
            >
              <span className="menu-icon">
                <img src={dashborad} alt="dashboard icon" />
              </span>
              <span>Dashboard</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/request" className={() => getActiveClass("/request")}>
              <span className="menu-icon">
                <img src={request} alt="request icon" />
              </span>
              <span>Requests</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/facilities"
              className={() => getActiveClass("/facilities")}
            >
              <span className="menu-icon">
                <img src={facility} alt="facility icon" />
              </span>
              <span>Facilities</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/professional"
              className={() => getActiveClass("/professional")}
            >
              <span className="menu-icon">
                <img src={facility} alt="professional icon" />
              </span>
              <span>Professionals</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/services"
              className={() => getActiveClass("/services")}
            >
              <span className="menu-icon">
                <img src={facility} alt="services icon" />
              </span>
              <span>Services</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/setting" className={() => getActiveClass("/setting")}>
              <span className="menu-icon">
                <img src={settingIcon} alt="setting icon" />
              </span>
              <span>Settings</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
